import { useState } from 'react';
import { ImageIcon } from 'lucide-react';

// Category-based emoji placeholder
function CategoryIcon({ categ }) {
  const name = (typeof categ === 'string' ? categ : categ?.[1] || '').toLowerCase();
  if (name.includes('مشروب') || name.includes('drink') || name.includes('bever') || name.includes('juice') || name.includes('water') || name.includes('مياه')) return '🥤';
  if (name.includes('غذ') || name.includes('food') || name.includes('معلب') || name.includes('طعام') || name.includes('بقال')) return '🍞';
  if (name.includes('منظف') || name.includes('clean') || name.includes('تنظيف')) return '🧹';
  if (name.includes('عناية') || name.includes('care') || name.includes('personal')) return '🧴';
  if (name.includes('تبغ') || name.includes('سجائر') || name.includes('tobacco')) return '🚬';
  if (name.includes('حلو') || name.includes('candy') || name.includes('chocolate') || name.includes('شوك')) return '🍫';
  if (name.includes('dairy') || name.includes('ألبان') || name.includes('لبن')) return '🥛';
  return null;
}

export default function ProductImage({ src, categ, size = 'card', className = '' }) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  const showImg = src && !errored;

  // Container dimensions per usage.
  // - card: fixed compact height (h-28 ≈ 112px) so the image area never
  //   dominates the card regardless of how wide the column is on desktop.
  // - detail: aspect-square on the product detail page — that page wants a
  //   prominent image.
  // - list/thumb: small fixed boxes for rows.
  const containerClass = {
    card: 'w-full h-28',
    list: 'w-14 h-14 flex-shrink-0',
    detail: 'w-full aspect-square max-h-80',
    thumb: 'w-10 h-10 flex-shrink-0',
  }[size] || 'w-full h-28';

  const emoji = CategoryIcon({ categ });

  // Sizing for the fallback icon
  const iconSize = {
    card: 'w-6 h-6',
    list: 'w-4 h-4',
    detail: 'w-12 h-12',
    thumb: 'w-3.5 h-3.5',
  }[size] || 'w-6 h-6';

  const emojiSize = {
    card: 'text-2xl',
    list: 'text-base',
    detail: 'text-5xl',
    thumb: 'text-base',
  }[size] || 'text-2xl';

  return (
    <div className={`${containerClass} bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl overflow-hidden flex items-center justify-center relative ${className}`}>
      {showImg ? (
        <>
          {!loaded && (
            <div className="absolute inset-0 bg-muted animate-pulse rounded-xl" />
          )}
          <img
            src={src}
            alt=""
            loading="lazy"
            onLoad={() => setLoaded(true)}
            onError={() => setErrored(true)}
            className={`w-full h-full object-contain transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          />
        </>
      ) : (
        <div className="flex items-center justify-center opacity-50">
          {emoji ? (
            <span className={emojiSize}>{emoji}</span>
          ) : (
            <ImageIcon className={iconSize} strokeWidth={1.5} color="#9ca3af" />
          )}
        </div>
      )}
    </div>
  );
}
